import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  inheritAttrs: false
}

import { ref, computed, reactive, useAttrs, watch } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FormInput',
  props: {
  value: { type: String, default: '' },
  error: { type: String, default: '' }
},
  emits: ['input', 'enter', 'change', 'keyup', 'blur'],
  setup(__props, { expose, emit }) {

const props = __props;

const attrs = useAttrs()





const input = reactive({ value: '', error: '' })
const inputRef = ref<HTMLInputElement | null>(null)

const isError = computed(() => props.error && props.error.length > 0)
const isInput = computed(() => props.value && props.value.length > 0)
const type = computed(() => (attrs.type as string) ?? 'text')

watch(() => props.value, (value) => {
  input.value = value
}, { immediate: true })

watch(() => props.error, (error) => {
  input.error = error
}, { immediate: true })

const checkedInputMaxLength = (value: string): string => {
  const maxLength = attrs.maxlength as number
  if (!isNaN(maxLength)) {
    value = value.slice(0, maxLength ?? 999)
  }
  return value
}

const focus = () => {
  setTimeout(() => {
    const input: HTMLInputElement | null = inputRef.value
    input && input.focus()
  }, 300)
}

const keyup = (event: Event) => {
  const target = event.target as HTMLInputElement
  input.value = checkedInputMaxLength(target.value)
  emit('keyup', input.value)
  emit('input', input.value)
}

const blur = (event: Event) => {
  const target = event.target as HTMLInputElement
  input.value = checkedInputMaxLength(target.value)
  emit('blur', input.value)
  emit('input', input.value)
  emit('change', input.value)
}

const paste = (event: Event) => {
  const target = event.target as HTMLInputElement
  input.value = checkedInputMaxLength(target.value)
  emit('input', input.value)
  emit('change', input.value)
}

const enter = () => {
  emit('enter')
}

const change = () => {
  emit('change', props.value)
}

const remove = () => {
  if (
    attrs.disabled || attrs.readonly
  ) {
    return
  }

  if (inputRef && inputRef.value) {
    const input: HTMLInputElement = inputRef.value

    focus()
    input.value = ''
    emit('keyup', input.value)
    emit('input', input.value)
    emit('change', input.value)
  }
}

expose({
  focus
})


return { __sfc: true,attrs, props, emit, input, inputRef, isError, isInput, type, checkedInputMaxLength, focus, keyup, blur, paste, enter, change, remove }
}

})